export default function localizedNumberText(value, language) {
  let result = ''
  let tobbProcessed = parseFloat(value)
  language = language.toLowerCase()

  if (tobbProcessed) {
    if (language === 'bd') {
      result = tobbProcessed.toLocaleString('bn-BD')
    } else if (language === 'en') {
      result = tobbProcessed.toLocaleString('en-US')
    } else {
      // Future language support fallback
      result = value
    }
  } else {
    return value
  }

  return result
}
